import { getModalWindow } from '@libs/network-utils';
import {
    LayoutEnum,
    TBottomSheetsWidgetsMap,
    TButtonData,
    TCommonData,
    TInternalWidgets,
    TModalWidgetsMap,
    TModalWindow,
    TMutableWidgetsData,
    TMutableWidgetsOption,
    TPayloadWidget,
    TWInternalId,
} from '@libs/types';

type TWidgetByActionWidgetId = {
    widget?: TPayloadWidget<TMutableWidgetsData & TButtonData, TMutableWidgetsOption>;
    internalIdWidgets: Record<string, string>;
    bottomSheetMap?: TBottomSheetsWidgetsMap;
    modalWindowMap?: TModalWidgetsMap;
};
export const getWidgetByActionWidgetId = (
    widgets: TPayloadWidget<TMutableWidgetsData & TButtonData, TMutableWidgetsOption>[],
    internalId: TWInternalId,
): TWidgetByActionWidgetId => {
    const result = {} as TWidgetByActionWidgetId;
    for (const widget of widgets) {
        if (widget?.internalId === internalId) {
            result.widget = widget;
            if (widget.widgets?.length > 0) {
                result.bottomSheetMap = { ...result?.bottomSheetMap, ...getModals(result.widget.widgets, LayoutEnum.BOTTOM_SHEET) };
                result.modalWindowMap = { ...result?.modalWindowMap, ...getModals(result.widget.widgets, LayoutEnum.MODAL_WINDOW) };
                result.internalIdWidgets = {
                    ...result?.internalIdWidgets,
                    ...getInternalIds(result.widget.widgets),
                };
            }
        } else if (Array.isArray(widget?.widgets) && widget.widgets.length > 0) {
            const someResult = getWidgetByActionWidgetId(widget.widgets, internalId);
            if (!result?.widget?.uid) {
                result.widget = someResult?.widget;
            }
            if (someResult.bottomSheetMap) {
                result.bottomSheetMap = { ...result?.bottomSheetMap, ...someResult.bottomSheetMap };
            }
            if (someResult.modalWindowMap) {
                result.modalWindowMap = { ...result?.modalWindowMap, ...someResult.modalWindowMap };
            }
            if (someResult.internalIdWidgets) {
                result.internalIdWidgets = { ...result?.internalIdWidgets, ...someResult.internalIdWidgets };
            }
        }
        if (widget?.internalId) {
            if (!result.internalIdWidgets) {
                result.internalIdWidgets = {};
            }
            result.internalIdWidgets[widget.internalId] = widget.uid;
            const bs = getModal(widget, LayoutEnum.BOTTOM_SHEET);
            const modal = getModal(widget, LayoutEnum.MODAL_WINDOW);
            if (bs) {
                if (!result.bottomSheetMap) {
                    result.bottomSheetMap = {};
                }
                result.bottomSheetMap[widget.internalId] = bs;
            } else if (modal) {
                if (!result.modalWindowMap) {
                    result.modalWindowMap = {};
                }
                result.modalWindowMap[widget.internalId] = modal;
            }
        }
    }
    return result;
};

const getModals = (widgets: Array<TPayloadWidget<TCommonData>>, layoutType: LayoutEnum): TBottomSheetsWidgetsMap => {
    let result = {} as TBottomSheetsWidgetsMap;
    for (const widget of widgets) {
        if (widget?.internalId) {
            const modal = getModal(widget, layoutType);
            if (modal) {
                result[widget?.internalId] = modal;
            }
        }
        if (widget.widgets?.length > 0) {
            result = { ...result, ...getModals(widget.widgets, layoutType) };
        }
    }
    return result;
};

const getInternalIds = (widgets: Array<TPayloadWidget<TCommonData>>): TInternalWidgets => {
    let result = {} as TInternalWidgets;
    for (const widget of widgets) {
        if (widget?.internalId && widget?.uid && widget?.id) {
            result[widget?.internalId] = widget?.uid;
        }
        if (widget?.widgets?.length > 0) {
            result = { ...result, ...getInternalIds(widget.widgets) };
        }
    }
    return result;
};

const getModal = (widget: TPayloadWidget<TCommonData>, layoutType: LayoutEnum): TModalWindow | undefined => {
    if (widget.internalId && (widget.alternativeId === layoutType || widget.id === layoutType)) {
        return getModalWindow(widget);
    }
    return undefined;
};
